<template>
    <div>
        <div class="mb-8">

            <div class="rounded bg-white shadow-md">
                <div class="flex flex-row rounded-t p-2 justify-between">
                    <span>Related Companies</span>
                </div>
                <div class="py-4 px-3 flex flex-wrap flex-lg-nowrap items-stretch">
                    <div class="flex-col w-full lg:w-1/3 pr-4">
                        <div class="mb-4 leading-tight">
                            <label class="text-grey-darkest text-sm" for="companies">Select a Child Company</label>
                            <multiselect
                                id="companies"
                                v-model="selectedCompany"
                                :options="allCompanies"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="false"
                                :taggable="true"
                                open-direction="below"
                                placeholder="Pick a company"
                                tag-placeholder="Add this company"
                                label="name"
                                track-by="id"
                                :preselect-first="false">
                            </multiselect>
                        </div>
                        <div v-if="selectedCompany">
                            <hr class="lg:hidden">
                            <div class="leading-tight">
                                <label class="text-grey-darkest text-sm"></label>
                                <div @click.prevent.stop="addOrRemoveCompany(selectedCompany)"
                                     class="p-2 hover:bg-grey-lighter flex justify-between items-center rounded cursor-pointer">
                                    <div class="flex items-baseline">
                                        <div class="font-medium mr-3 text-sm font-light text-grey-darkest">{{ selectedCompany.name }}
                                        </div>
                                        <div class="text-sm font-light text-grey-darkest hidden lg:inline">
                                            {{ selectedCompany.phone }}
                                        </div>
                                    </div>
                                    <button v-if="!companyAddedAlready(selectedCompany) && canEdit"
                                            @click.prevent.stop="addCompany(selectedCompany)"
                                            class="border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:text-white material-icons p-1 rounded-full text-base text-followup-nav">
                                        add
                                    </button>
                                    <span v-else-if="canEdit" @click.prevent.stop="removeCompany(selectedCompany)"
                                          class="border-2 border-red focus:outline-none font-semibold hover:bg-red hover:text-white material-icons p-1 rounded-full text-base text-red">
                                        close
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="hidden lg:flex border-1 border-grey mr-4"></div>
                    <div class="flex-1">
                        <hr class="lg:hidden">
                        <table class="w-full">
                            <thead>
                            <tr>
                                <th class="pb-2 pl-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light">
                                    Child Company Name
                                </th>
                                <th class="pb-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light">
                                    Company Address
                                </th>
                                <th class="pb-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                                    Email/Phone
                                </th>
                                <th class="pb-2 hidden xl:table-cell"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="company in form.relatedCompanies" @click.prevent.stop="goToCompany(company)"
                                class="hover:bg-grey-lighter rounded cursor-pointer">
                                <td class="p-2 text-sm font-light text-grey-darkest text-grey-darkest">{{ company.name }}</td>
                                <td class="p-2 text-sm font-light text-grey-darkest text-grey-darkest">
                                    {{ company.address }}  {{ company.state }}
                                </td>
                                <td class="p-2 text-sm font-light text-grey-darkest hidden lg:table-cell">
                                    {{ company.phone }}
                                </td>
                                <td class="pt-2">
                                    <button v-if="canEdit" @click.prevent.stop="removeCompany(company)"
                                            class="focus:outline-none text-base font-light text-grey-darkest hover:text-grey-darkest material-icons">
                                        delete
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Form from "../../utils/form";
import Multiselect from 'vue-multiselect';

export default {
    name: 'related-companies',
    props: ['company', 'masks', 'symbols', 'relatedCompanies', 'canEdit'],
    components: {Multiselect},

    data() {

        return {
            form: new Form({
                relatedCompanies: this.relatedCompanies ?? [],
            }),
            selectedCompany: null,
            allCompanies: [],
        }
    },

    created() {
        this.fetchCompanies();
    },
    methods: {
        goToCompany(company) {
            window.location = route('company.show', {company: company.id});
        },

        addCompany(relatedCompany) {
            var companiesPushed =this.form.relatedCompanies.push(relatedCompany);
            this.$emit('companiesPushed', this.form.relatedCompanies)
        },

        removeCompany(relatedCompany) {
            this.form.relatedCompanies = this.form.relatedCompanies.filter(function (addedCompany) {
                return addedCompany.id !== relatedCompany.id;
            });
            this.$emit('companiesPushed', this.form.relatedCompanies)
        },

        addOrRemoveCompany(relatedCompany) {
            if(this.canEdit){
                this.companyAddedAlready(relatedCompany) ? this.removeCompany(relatedCompany) : this.addCompany(relatedCompany);
            }
        },

        companyAddedAlready(relatedCompany) {
            return this.form.relatedCompanies.filter(x => relatedCompany.id === x.id).length > 0;
        },

        fetchCompanies() {
            axios.get(route('api.company.companies')).then(({data}) => {
                this.allCompanies = data.data.filter(x => this.company.id !== x.id)

            })
        },
    }
}
</script>
